export enum ProductKey {
	JIRA_SOFTWARE = 'jira-software.ondemand',
	CONFLUENCE = 'confluence.ondemand',
	LOOM = 'loom',
	ROVO = 'rovo.ondemand',
}

export type ProductLicenseResponse = {
	products: {
		[key in ProductKey]?: {
			state: 'ACTIVE' | 'INACTIVE'; // Only tracking active/inactive state
		};
	};
};
